import { LogService } from 'library/ts/utilities/logger/LogService';
export class Store {
    static _instance = new Store();
    #available;
    #logger;
    constructor() {
        if (Store._instance) {
            throw new Error(this.name + ' is a Singleton and can only be accessed through ' + this.name + '.getInstance()');
        }
        Store._instance = this;
        this.#logger = LogService.create({ prefixes: ['SmartTag:', this.name + ':'] });
        const test = 'test' + new Date().getTime();
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            this.#available = true;
        }
        catch (error) {
            this.#available = true;
        }
    }
    get name() {
        return 'Store';
    }
    get available() {
        return this.#available;
    }
    get utils() {
        return window?.PARA?.PlayerServices?.Utilities;
    }
    static getInstance() {
        return Store._instance;
    }
    set = (key, value) => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch (error) {
            this.#logger.warn('set:', value, 'ERROR:', error);
        }
    };
    get = (key) => {
        let value;
        try {
            value = localStorage.getItem(key);
        }
        catch (error) {
            this.#logger.warn(`get: ${key}: ${value}`, 'ERROR:', error);
        }
        if (!this.utils.Type.isString(value)) {
            return undefined;
        }
        try {
            return JSON.parse(value);
        }
        catch (error) {
            return value || undefined;
        }
    };
    remove = (key) => {
        try {
            localStorage.removeItem(key);
        }
        catch (error) {
            this.#logger.warn('remove:', key, 'ERROR:', error);
        }
    };
    clear = () => {
        try {
            localStorage.clear();
        }
        catch (error) {
            this.#logger.warn('clear:', 'ERROR:', error);
        }
    };
}
